// Import api
import { api } from 'store/api';

// Import types
import type { AgreementsModificationType, SubscriberAgreementsType } from 'types/api/agreements';

const enhancedApi = api.enhanceEndpoints({
	addTagTypes: ['user_agreements']
});

export const subscriberAgreementsApi = enhancedApi.injectEndpoints({
	endpoints: (builder) => ({
		getSubscriberAgreements: builder.query<SubscriberAgreementsType, void>({
			query: () => ({ url: '/subscriber/agreements' }),
			// TO DO - after user page refactor agreements can be cached
			keepUnusedDataFor: 0,
			providesTags: ['user_agreements']
		}),
		updateSubscriberAgreements: builder.mutation<SubscriberAgreementsType, { agreement_version_ids: number[]; type: AgreementsModificationType }>({
			query: ({ agreement_version_ids, type }) => {
				return { url: `/subscriber/agreements/${type}`, method: 'POST', body: { agreement_version_ids } };
			},

			invalidatesTags: (result, error) => (error ? [] : ['user_agreements'])
		})
	})
});

export const { useGetSubscriberAgreementsQuery, useUpdateSubscriberAgreementsMutation } = subscriberAgreementsApi;
